import type { AggregatorDetailsProfileFormValues } from "./AggregatorDetailsProfile";
import type { AdministrativeAreaOption } from "@/components/AdministrativeAreaTreeSelect";
import type { AdministratorFormValues } from "./AdministratorModal";

export const STEP_IDS = {
  DETAILS: "details",
  ADMINISTRATORS: "administrators",
} as const;

export type StepId = (typeof STEP_IDS)[keyof typeof STEP_IDS];
export type EntityId = number | string | null | undefined;
export type TranslationFunction = (key: string, options?: Record<string, unknown>) => string;
export type OptionValue = string | number;

export interface SelectOption {
  value: OptionValue;
  label: string;
  [key: string]: unknown;
}

export interface AdministratorPerson {
  full_name?: string;
  [key: string]: unknown;
}

export interface AggregatorAdministrator {
  id?: number | string;
  uuid?: string;
  email?: string;
  active?: boolean;
  account_type?: string;
  person?: AdministratorPerson;
  [key: string]: unknown;
}

export type ProfileSubmitHandler = (
  values: AggregatorDetailsProfileFormValues
) => void | Promise<void>;

export type AdministratorActionHandler = (administrator: AggregatorAdministrator) => void;

export type AdministratorSubmitHandler = (values: AdministratorFormValues) => void | Promise<void>;

export interface AggregatorDetailsFormProps {
  id?: EntityId;
  isFetching: boolean;
  errorMessage?: string;
  onClickValidateAndClose: ProfileSubmitHandler;
  onClickValidateAndContinue: ProfileSubmitHandler;
  aggregatorAdministrators: AggregatorAdministrator[];
  onClickEditAdministrator: AdministratorActionHandler;
  onClickDeleteAdministrator: AdministratorActionHandler;
  onClickEnableAdministrator: AdministratorActionHandler;
  isDeleteAdministratorModalOpen: boolean;
  onClickConfirmDeleteAdministrator: () => void | Promise<void>;
  onClickCancelDeleteAdministrator: () => void;
  currentToDeleteAdministrator?: AggregatorAdministrator | null;
  isFetchingDeleteAdministrator: boolean;
  errorMessageDeleteAdministrator: string;
  organizationTypes: SelectOption[];
  administrativeAreas: AdministrativeAreaOption[];
  initialStep?: number;
  initialValues?: AggregatorDetailsProfileFormValues;
  isSavingProfile?: boolean;
  isFetchingAggregatorAdministrators?: boolean;
  initialFormValuesAdministrator?: Partial<AdministratorFormValues>;
  isFetchingAdministrator?: boolean;
  errorMessageAdministrator?: string;
  fieldErrorsAdministrator?: Record<string, unknown>;
  onClickValidateAdministratorModal: AdministratorSubmitHandler;
  isOnEditAdministrator?: boolean;
  onClickCloseAdministrator: () => void;
  isEnableAdministratorModalOpen?: boolean;
  onClickConfirmEnableAdministrator: () => void | Promise<void>;
  onClickCancelEnableAdministrator: () => void;
  currentToEnableAdministrator?: AggregatorAdministrator | null;
  isFetchingEnableAdministrator?: boolean;
  errorMessageEnableAdministrator?: string;
  onClickAddAdministrator?: () => void;
  languages?: unknown[];
  cardTypes?: unknown[];
  setFieldError?: (...args: unknown[]) => void;
}
